const breakpoints = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
};

export const getColumnWidth = (field) => {
  const widthMap = {
    column: {
      xs: 200,
      sm: 200,
      md: 200,
      lg: 200,
      xl: 200,
    },
    column1: {
      xs: 250,
      sm: 250,
      md: 250,
      lg: 250,
      xl: 250,
    },
    column2: {
      xs: 150,
      sm: 150,
      md: 150,
      lg: 150,
      xl: 150,
    },
    column3: {
      xs: 250,
      sm: 250,
      md: 250,
      lg: 250,
      xl: 250,
    },
    column4: {
      xs: 300,
      sm: 300,
      md: 300,
      lg: 300,
      xl: 300,
    },
    action: {
      xs: 100,
      sm: 100,
      md: 100,
      lg: 100,
      xl: 100,
    },
    actions: {
      xs: 300,
      sm: 300,
      md: 300,
      lg: 300,
      xl: 300,
    },
  };

  const screenWidth = window.innerWidth;

  if (screenWidth < breakpoints.sm) {
    return widthMap[field]?.xs || 100;
  } else if (screenWidth < breakpoints.md) {
    return widthMap[field]?.sm || 100;
  } else if (screenWidth < breakpoints.lg) {
    return widthMap[field]?.md || 100;
  } else if (screenWidth < breakpoints.xl) {
    return widthMap[field]?.lg || 100;
  } else {
    return widthMap[field]?.xl || 100;
  }
};
